import {getIn} from 'formik'

const isInvalid = (errors, touched, fieldName) => Boolean(getIn(errors, fieldName) && getIn(touched, fieldName))

export default isInvalid
